// @ts-nocheck
import React from "react";
import { useSelector } from "react-redux";
import { FaPhoneAlt, FaClock, FaMapMarkerAlt } from "react-icons/fa";
import vivasLogo from "../assets/images/vivas-logo.png";
import { useLanguageContext } from "../context/languageContext";
import { FALLBACK_BUSINESS } from "../data/fallback";

const CONCIERGE_PHONE = "+355 68 20 42 980";
const CONCIERGE_PHONE_RAW = "355682042980";

/**
 * Contact card at the foot of the page.
 *
 * Deliberately quiet: a neutral card with a thin brand edge rather than a large
 * block of colour, so it reads as practical information and not as an advert.
 * The logo artwork is white, so it needs the navy tile to be visible here.
 */
export const SubBanner = () => {
    const { t } = useLanguageContext();
    // Whatever the API returned, or the bundled copy of it when it could not be reached.
    const business = useSelector((state) => state.business.businessInfo) || FALLBACK_BUSINESS;
    // The stored address usually names the city already ("Plazh , Durres"), and it is
    // typed by hand, so tidy the spacing and only add the city when it is missing.
    const street = (business.address || "").replace(/\s+,/g, ",").replace(/\s+/g, " ").trim();
    const city = (business.city || "").trim();
    const address = city && !new RegExp(city, "i").test(street)
        ? [street, city].filter(Boolean).join(", ")
        : street;
    const mapsUrl = `https://maps.google.com/?q=${encodeURIComponent([business.businessName, address].filter(Boolean).join(" "))}`;

    return (
        <section className="px-4 pt-2 pb-6">
            <div className="rounded-2xl bg-white border border-slate-200/70 shadow-[0_2px_12px_-8px_rgba(0,0,0,0.15)] overflow-hidden">
                <div className="h-[3px] bg-brand"></div>

                <div className="p-4 space-y-3.5">
                    <div className="flex items-center gap-3">
                        <div className="w-9 h-9 flex-shrink-0 rounded-full bg-navy flex items-center justify-center">
                            <img src={vivasLogo} alt="Hotel Vivas" className="w-7 h-7 object-contain" />
                        </div>
                        <div className="min-w-0">
                            <p className="text-[13px] font-bold text-slate-900 leading-tight truncate">
                                {business.businessName || "Hotel Vivas"}
                            </p>
                            <p className="text-[10px] font-black uppercase tracking-[0.15em] text-slate-400">
                                Hotel Vivas Luxury
                            </p>
                        </div>
                    </div>

                    <div className="space-y-2 pt-0.5">
                        {address && (
                            <a
                                href={mapsUrl}
                                target="_blank"
                                rel="noreferrer"
                                className="flex items-start gap-2.5 text-slate-600 active:text-brand transition-colors"
                            >
                                <FaMapMarkerAlt className="text-brand mt-[3px] flex-shrink-0" size={11} />
                                <span className="text-[11.5px] font-medium leading-snug">{address}</span>
                            </a>
                        )}
                        <div className="flex items-center gap-2.5 text-slate-600">
                            <FaClock className="text-brand flex-shrink-0" size={11} />
                            <span className="text-[11.5px] font-medium">
                                {t("Digital Concierge", "Digital Concierge")} · {t("24/7 Service", "24/7 Service")}
                            </span>
                        </div>
                    </div>

                    <a
                        href={`tel:+${CONCIERGE_PHONE_RAW}`}
                        className="flex items-center justify-center gap-2 h-11 rounded-xl bg-brand text-white text-[11px] font-black uppercase tracking-widest active:scale-[0.98] transition-transform"
                    >
                        <FaPhoneAlt size={11} />
                        {CONCIERGE_PHONE}
                    </a>
                </div>
            </div>
        </section>
    );
};
